
import { LetterBox } from "./LetterBox";

interface PrevLevelAnswerProps {
  word: string;
  guess: { letter: string; status: string }[];
}

export const PrevLevelAnswer = ({ word, guess }: PrevLevelAnswerProps) => {
  const getLetterStatus = (status: string): "correct" | "wrong-position" | "incorrect" | "empty" | "completed" => {
    if (status === "misplaced") return "wrong-position";
    return status as "correct" | "wrong-position" | "incorrect" | "empty" | "completed";
  };

  return (
    <div 
      className="flex justify-center mb-1 px-3 py-1 w-full rounded-b-xl shadow-lg bg-gradient-to-b from-black/50 to-black/30"
    >
      <div
        className="letter-grid grid animate-fade-in"
        style={{ 
          gridTemplateColumns: `repeat(${word.length}, 1fr)`,
          gap: '2px',
          display: 'inline-grid' // Enforce inline grid to prevent stretching
        }}
      >
        {Array.from({ length: word.length }).map((_, index) => (
          <LetterBox
            key={index}
            letter={guess[index].letter}
            status={getLetterStatus(guess[index].status)}
            index={index}
            isCompact={true}
          />
        ))}
      </div>
    </div>
  );
};
